import { render, staticRenderFns } from "./coping-with-header.vue?vue&type=template&id=86d7e11a&"
import script from "./coping-with-header.vue?vue&type=script&lang=js&"
export * from "./coping-with-header.vue?vue&type=script&lang=js&"
import style0 from "./coping-with-header.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports